import { useCallback, useReducer } from 'react';

import {
  ReducerAction,
  ReducerActionType,
} from './pc-feedback-form-reducer-actions';

type State = {
  lessonId?: number;
  isLessonSubmitted: boolean;
  classroomId?: number;
  teacherId?: number;
  studentId?: number;
  teacherFeedback?: string;
  recommendedRepeat: boolean;
};

function pcFeedbackFormReducer(state: State, action: ReducerAction): State {
  const { type, payload } = action;

  switch (type) {
    case ReducerActionType.FEEDBACK_INIT:
      return {
        ...initialState,
        ...payload,
      };

    case ReducerActionType.LESSON_SELECTED:
      return {
        ...state,
        ...payload,
      };

    case ReducerActionType.LESSON_SUBMITTED:
      return {
        ...state,
        isLessonSubmitted: true,
      };

    case ReducerActionType.RESTORE_SUBMITTED_LESSON:
      return {
        ...state,
        ...payload,
        teacherFeedback: '',
        recommendedRepeat: false,
        isLessonSubmitted: true,
      };

    case ReducerActionType.LESSON_RESET:
      return {
        ...state,
        isLessonSubmitted: false,
        teacherFeedback: '',
        recommendedRepeat: false,
      };

    default:
      return state;
  }
}

const initialState: State = {
  recommendedRepeat: false,
  isLessonSubmitted: false,
};

export const usePcFeedbackFormReducer = () => {
  const [state, dispatch] = useReducer(pcFeedbackFormReducer, {
    ...initialState,
  });

  const feedbackInit = useCallback(
    (payload: {
      classroomId: number;
      teacherId: number;
      studentId: number;
    }) => {
      dispatch({
        type: ReducerActionType.FEEDBACK_INIT,
        payload,
      });
    },
    []
  );

  const lessonSelected = useCallback((lessonId: number) => {
    dispatch({
      type: ReducerActionType.LESSON_SELECTED,
      payload: { lessonId },
    });
  }, []);

  const lessonSubmitted = useCallback(() => {
    dispatch({
      type: ReducerActionType.LESSON_SUBMITTED,
      payload: {},
    });
  }, []);

  const lessonReset = useCallback(() => {
    dispatch({
      type: ReducerActionType.LESSON_RESET,
      payload: {},
    });
  }, []);

  const restoreSubmittedLesson = useCallback(
    (payload: {
      classroomId: number;
      teacherId: number;
      studentId: number;
      lessonId: number;
    }) => {
      dispatch({
        type: ReducerActionType.RESTORE_SUBMITTED_LESSON,
        payload,
      });
    },
    []
  );

  return {
    ...state,
    feedbackInit,
    lessonSelected,
    lessonSubmitted,
    restoreSubmittedLesson,
    lessonReset,
  };
};
